import Swiper from 'swiper'
import { Pagination, Autoplay, EffectFade, Navigation } from 'swiper/modules'
import 'swiper/css'
import 'swiper/css/pagination'
import 'swiper/css/effect-fade'

class Slide {
    constructor() {
        this.SlideBillboard()
        this.SlideBusiness()
        this.SlideESG()
        this.SlideLifeAtmbk()
    }


    SlideBillboard() {
     
        const observer = new MutationObserver((mutations) => {
            const swiperEl = document.querySelector('.swiper--billboard');
            if (swiperEl) {
                
                var swiper = new Swiper('.swiper--billboard', {
                    modules: [Autoplay, Pagination, EffectFade],
                    loop: true,
                    speed: 1000,
                    effect: "fade",
                    fadeEffect: {
                        crossFade: true
                    },
                    autoplay: {
                        delay: 8000,
                        disableOnInteraction: false
                    },
                    pagination: {
                        el: '.swiper-pagination',
                        clickable: true,
                    },
                });
                
                observer.disconnect(); 
            }
        });
        
        observer.observe(document.body, {
            childList: true,
            subtree: true
        });
    }

    SlideBusiness() {
     
        const observer = new MutationObserver((mutations) => {
            const swiperEl = document.querySelector('.swiper--business');
            if (swiperEl) {
                
                var swiper = new Swiper('.swiper--business', {
                    modules: [Pagination, Autoplay, EffectFade],
                    slidesPerView: 1,
                    loop: true,
                    speed: 2000,
                    effect: "fade",
                    draggable: true,
                    autoplay: {
                        delay: 2000,
                        pauseOnMouseEnter: false,
                        disableOnInteraction: false,
                    },
                    pagination: {
                        el: '.swiper-pagination',
                        clickable: true,
                    },
                });
                
                observer.disconnect(); 
            }
        });
        
        observer.observe(document.body, {
            childList: true,
            subtree: true
        });
    }

    SlideESG() {
     
        const observer = new MutationObserver((mutations) => {
            const swiperEl = document.querySelector('.swiper--esg');
            if (swiperEl) {
                
                var swiper = new Swiper('.swiper--esg', {
                    modules: [Pagination, Autoplay, EffectFade, Navigation],
                    slidesPerView: 1,
                    loop: true,
                   //speed: 2000,
                   // effect: "fade",
                    draggable: true,
                    // autoplay: {
                    //     delay: 2000,
                    //     pauseOnMouseEnter: false,
                    //     disableOnInteraction: false,
                    // },
                    // pagination: {
                    //     el: '.swiper-pagination',
                    //     clickable: true,
                    // },
                    navigation: {
                        nextEl: '.swiper-button-esg .swiper-button-next',
                        prevEl: '.swiper-button-esg .swiper-button-prev',
                    },
                });
                
                observer.disconnect(); 
            }
        });
        
        observer.observe(document.body, {
            childList: true,
            subtree: true
        });
    }

    SlideLifeAtmbk() {
    
    const observer = new MutationObserver((mutations) => {
        const swiperEl = document.querySelector('.swiper--life-at-mbk');
        if (swiperEl) {
            
            var swiper = new Swiper('.swiper--life-at-mbk', {
                modules: [Pagination, Autoplay, EffectFade, Navigation],
                slidesPerView: 1,
                loop: true,
                //speed: 2000,
                // effect: "fade",
                draggable: true,
                // autoplay: {
                //     delay: 2000,
                //     pauseOnMouseEnter: false,
                //     disableOnInteraction: false,
                // },
                pagination: {
                    el: '.swiper-pagination',
                    clickable: true,
                },
                navigation: {
                    nextEl: '.swiper-button-life-at-mbk .swiper-button-next',
                    prevEl: '.swiper-button-life-at-mbk .swiper-button-prev',
                },
            });
            
            observer.disconnect(); 
        }
    });
    
    observer.observe(document.body, {
        childList: true,
        subtree: true
    });
    }
}

export default Slide